import React, { useEffect } from "react";
import { Dropdown } from "primereact/dropdown";
import { useContextSimulator } from "../SimulatorContext";

const AccordionSale = ({ sellerId = null }) => {
  const {
    simulatorData,
    members,
    setMemberData,
    loadingTeams,
    team,
    handleTeam,
    imobiliarias,
    corretores,
    selectedImob,
    setSelectedImob,
    selectedCorr,
    setSelectedCorr,
    crmData,
  } = useContextSimulator();

  const handleMemberData = (memberId) => {
    // console.log(members)
    if(!members || members === null || members?.length === 0) return;
    const filter = members.filter((member) => member.id === parseInt(memberId));
    setMemberData(filter[0]);
  };

  useEffect(() => {
    if (sellerId !== null) {
      handleMemberData(parseInt(sellerId));
      setSelectedCorr(parseInt(sellerId));
    }
  }, [sellerId, team, selectedImob]);

  useEffect(() => {
    if(sellerId && crmData) {
      handleTeam(crmData?.team_id);
    }
  }, [sellerId, crmData]);
  
  return (
    <div className="row">
      {simulatorData?.teams && (
        <>
          <div className="col-md-4 pb-2">
            <label className="mb-3">Time de Venda *</label>
            <Dropdown
              value={team}
              onChange={(e) => handleTeam(e.value)}
              emptyFilterMessage="Nenhuma informação encontrada."
              emptyMessage="Nenhuma informação encontrada."
              showClear
              filter
              disabled={!simulatorData?.teams || crmData?.team_id}
              options={
                simulatorData &&
                simulatorData.teams.map((team) => ({
                  label: team.name,
                  value: team.id,
                }))
              }
              optionLabel="label"
              placeholder="Selecione"
              className="bg-none px-0 w-100"
            />
          </div>
          <div className="col-md-4 pb-2">
            <label className="mb-3">Imobiliária *</label>
            <Dropdown
              value={selectedImob}
              showClear
              filter
              onChange={(e) => setSelectedImob(e.value)}
              options={imobiliarias}
              optionLabel="label"
              emptyFilterMessage="Nenhuma informação encontrada."
              emptyMessage="Nenhuma informação encontrada."
              disabled={loadingTeams}
              placeholder={loadingTeams && team ? "Carregando..." : "Selecione"}
              className="bg-none px-0 w-100"
            />
          </div>
          <div className="col-md-4 pb-2">
            <label className="mb-3">Vendedor *</label>
            <Dropdown
              showClear
              filter
              value={selectedCorr}
              onChange={(e) => {
                setSelectedCorr(e.value);
                handleMemberData(e.value);
              }}
              options={corretores}
              optionLabel="label"
              disabled={loadingTeams || sellerId !== null}
              placeholder={loadingTeams && team ? "Carregando..." : "Selecione"}
              className="bg-none px-0 w-100"
            />
          </div>
        </>
      )}
    </div>
  );
};

export default AccordionSale;
